export const CalculationSetupQueries = {
  QUERY_GET_LIST_REWARD_CONDITION: `query GetRewardSetup($input: TrewardSetupWhereInput!, $skip: Float!, $take: Float!){
    getRewardSetup(where: $input, skip: $skip, take: $take,orderBy:{id: ASC}){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            mainSetupId
            type
            supportYn
            groupRoleManagement
            groupRoleId
            groupRoleName
            condition
            grossProfit
            grossProfitCalculate
            maxCondition
            realRevenue
            realRevenueCalculate
            note
            value
            valueType
            trealRevenueCalculate{
                id
                name
            }
            ttype{
                id
                name
            }
            tcreateUser{
                id
                fullName
            }
            createDate
            tmodifyUser{
                id
                fullName
            }
            modifyDate
        }
    }
}`,
  QUERY_GET_LIST_REWARD_FRAME: `query GetAllExpenses($input: TrewardSeqmentWhereInput!, $skip: Float!, $take: Float!){
    getRewardSeqment(where: $input, skip: $skip, take: $take, orderBy:{rewardSetupId: ASC, rewardSeqment: ASC}){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            rewardSetupId
            rewardSeqment
            fromCondition
            fromPercent
            toCondition
            toPercent
            rewardAmount
            useYn
            ttype{
                id
                name
            }
            createDate
            tcreateUser{
                id
                fullName
            }
            modifyDate
            tmodifyUser{
                id
                fullName
            }
        }
    }
}`,
  QUERY_CREATE_REWARD_CONDITION: `mutation GetRewardSetup($input: TrewardSetupInput!){
    createRewardSetup(input: $input,){
        id
        condition
        grossProfit
        grossProfitCalculate
        maxCondition
        maxConditionCaculate
        note
        realRevenue
        realRevenueCalculateId
        value
    }
}`,
  QUERY_CREATE_REWARD_FRAME: `mutation GetAllExpenses($input: TrewardSeqmentInput!) {
  createRewardSeqment(input: $input) {
    id
    rewardSetupId
    dmsTypeId
    fromCondition
    fromPercent
    groupId
    jobTitleId
    noteCondition
    rewardsSegId
    objectType
    rewardAmount
    rewardSetupId
    targetTypeId
    toCondition
    toPercent
    unitId1
    unitId2
    unitId3
    unitId4
    unitName1
    unitName2
    unitName3
    unitName4
  }
}`,

  // Get combobox reward setup
  GET_COMBOBOX_REWARD_SETUP: `query GetComboboxRewardSetup($input: TrewardSetupWhereInput!, $skip: Float!, $take: Float!){
        getRewardSetup(where: $input, skip: $skip, take: $take){
            pageInfo{
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
                id
                mainSetupId
                type
            }
        }
    }`,

  // Get combobox group Role Management
  GET_COMBOBOX_GROUP_ROLE_MANAGEMENT: `query GetComboboxGroupRoleManagement($input: TgroupRoleManagementWhereInput!, $skip: Float!, $take: Float!){
    getGroupRoleManagement(where: $input, skip: $skip, take: $take, orderBy:{rewardId: ASC}){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            rewardId
            plantId
            tjtobTitle{
                id
                jobName
            }
        }
    }
}`,
  // Create Reward Seup
  QUERY_CREATE_REWARD_SETUP: `mutation CreateRewardSetup($input: TrewardSetupInput!){
        createRewardSetup(input: $input){
            id
            mainSetupId
            type
            supportYn
            groupRoleManagement
            groupRoleId
            groupRoleName
            condition
            value
            valueType
        }
    }`,
  // Update Reward Seup
  QUERY_UPDATE_REWARD_SETUP: `mutation UpdateRewardSetup($input: TrewardSetupInput!){
        updateRewardSetup(input: $input){
            id
            mainSetupId
            type
            supportYn
            groupRoleManagement
            groupRoleId
            groupRoleName
            condition
            value
            valueType
        }
    }`,
  // Update Reward Seqment status
  UPDATE_REWARD_SEQMENT_STATUS: `mutation UpdateRewardSeqment($input: TrewardSeqmentInput!) {
  updateRewardSeqment(input: $input) {
    id
    useYn
  }
}
`,
  // Update Reward Seqment by id
  UPDATE_REWARD_SEQMENT_BY_ID: `mutation UpdateRewardSeqment($input: TrewardSeqmentInput!) {
  updateRewardSeqment(input: $input) {
    id
    fromCondition
    fromPercent
    toCondition
    toPercent
    rewardAmount
  }
}
`,
};
